
import { defineComponent, computed, reactive } from "vue";
export default defineComponent({
  setup() {
    // if( document.getElementById('Loading'))document.getElementById('Loading').remove();
  },
});
